import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const permissionInit = {
  permissions: {},
  isLoadingPermissions: false,
};

function permissionReducer(draft, { type, payload }) {
  switch (type) {
    case "setPermissions": {
      payload.Permissions.forEach(
        (permission) => (draft.permissions[[permission.id]] = permission)
      );
      break;
    }
    case "setIsLoadingPermissions": {
      draft.isLoadingPermissions = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [PermissionContext, PermissionDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function PermissionProvider({ children }) {
  const [permissionSotre, dispatch] = useImmerReducer(permissionReducer, permissionInit);

  return (
    <PermissionContext.Provider value={permissionSotre}>
      <PermissionDispatchContext.Provider value={dispatch}>
        {children}
      </PermissionDispatchContext.Provider>
    </PermissionContext.Provider>
  );
}

export function usePermissionStore() {
  return useContext(PermissionContext);
}

export function usePermissionDispatch() {
  return useContext(PermissionDispatchContext);
}